// This file was generated automatically. Manual changes will not be applied 
 export default {
  "lastUpdated": "2026-11-02T00:12:46.577Z",
  "supportedLanguages": [
    "de",
    "en",
    "uk"
  ],
  "docs": {
    "filesMap": "filesMap.b237cc3f.json",
    "contentsMap": {
      "de": "content.61d166c5.json",
      "en": "content.5e190b35.json",
      "uk": "content.3f4e0ae1.json"
    },
    "infoPaneMap": {
      "assets": {},
      "de": {
        "CreateAccount.md": "de/infoPane/CreateAccount.0fd227c2.md"
      },
      "en": {
        "CreateAccount.md": "en/infoPane/CreateAccount.8100570e.md"
      },
      "uk": {
        "CreateAccount.md": "uk/infoPane/CreateAccount.7d2ca8b9.md"
      }
    }
  },
  "localesMap": {
    "de": {
      "common": "/de/common.b768f9e1.json",
      "createAccount": "/de/createAccount.a8e11867.json",
      "development": "/de/development.f8ed2c36.json",
      "documentation": "/de/documentation.7391af0d.json",
      "home": "/de/home.c15098b3.json",
      "selectAccount": "/de/selectAccount.9a7e246e.json",
      "translation": "/de/translation.5a30ed72.json"
    },
    "en": {
      "common": "/en/common.0048d582.json",
      "createAccount": "/en/createAccount.6527e158.json",
      "development": "/en/development.991c292c.json",
      "documentation": "/en/documentation.3bb98277.json",
      "home": "/en/home.27ff5ab1.json",
      "selectAccount": "/en/selectAccount.541f0c0a.json",
      "translation": "/en/translation.85613d27.json"
    },
    "uk": {
      "common": "/uk/common.8095264a.json",
      "createAccount": "/uk/createAccount.9b905091.json",
      "development": "/uk/development.fdffea7d.json",
      "documentation": "/uk/documentation.5abf9d7f.json",
      "home": "/uk/home.6887d38b.json",
      "selectAccount": "/uk/selectAccount.ab6ba9b0.json",
      "translation": "/uk/translation.89222058.json"
    }
  }
};